import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, ReplaySubject } from 'rxjs';

import { RequestLoaderService } from '@services/request-loader.service';
import { appLoaderAnimationTypes } from '@shared/request-loader/interfaces';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'request-loader',
  templateUrl: './request-loader.component.html',
  styleUrls: ['./request-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestLoaderComponent implements OnInit, OnDestroy {
  public isLoadingAPI: boolean;

  public loaderConfig: {
    animationType: string;
    fullScreenBackdrop: boolean;
  } = {
    animationType: appLoaderAnimationTypes.threeBounce,
    fullScreenBackdrop: true,
  };

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private uiService: RequestLoaderService, public ref: ChangeDetectorRef) {}

  public ngOnInit(): void {
    combineLatest([this.uiService.isLoadingAPIVal$, this.uiService.isLoadingUIVal$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([valueAPI, valueUI]: [boolean, boolean]) => {
        this.isLoadingAPI = !valueUI ? valueAPI : false;
        if (valueUI) {
          this.uiService.hideAPILoader();
        }
        this.ref.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }
}
